<div [style]='"max-width:"+size+"px;"+style' class='lottie-boma-loading-container'>
  <ng-lottie [options]='options'></ng-lottie>
</div>
